import React from 'react';
import { Star } from 'lucide-react';
export function TestimonialsSection() {
  const testimonials = [{
    initials: 'VM',
    quote: 'Tres años en terapia girando en círculos. En una semana con este sistema identifiqué el patrón detrás de todo.',
    name: 'Valeria M.',
    details: '34 años, Buenos Aires'
  }, {
    initials: 'CR',
    quote: 'Las preguntas me llevaron a un lugar que nunca había visto. Por primera vez me entendí de verdad. Y soy psicóloga.',
    name: 'Claudia R.',
    details: '41 años, Rosario'
  }, {
    initials: 'MS',
    quote: 'Hice cursos carísimos que no me movieron. Este es diferente porque no te explica: te lleva. No es lo mismo.',
    name: 'Marcela S.',
    details: '29 años, Córdoba'
  }];
  return <section className="w-full px-4 py-6 md:py-10 bg-white" data-id="element-142">
      <div className="max-w-4xl mx-auto space-y-4" data-id="element-143">
        <h2 className="text-2xl md:text-3xl font-serif font-bold text-center text-text-main" data-id="element-144">
          Lo que dicen ellas
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-3" data-id="element-145">
          {testimonials.map((test, index) => <div key={index} className="bg-background p-4 rounded-xl shadow-sm border border-gray-100 flex flex-col" data-id="element-146">
              <div className="flex items-center gap-2 mb-2" data-id="element-147">
                <div className="w-8 h-8 bg-primary/10 text-primary font-serif font-bold rounded-full flex items-center justify-center text-sm" data-id="element-148">
                  {test.initials}
                </div>
                <div className="flex text-bonus" data-id="element-149">
                  {[...Array(5)].map((_, i) => <Star key={i} className="w-3 h-3 fill-current" data-id="element-150" />)}
                </div>
              </div>
              <p className="text-text-main text-sm italic mb-3 flex-grow leading-snug" data-id="element-151">
                "{test.quote}"
              </p>
              <div className="pt-2 border-t border-gray-200" data-id="element-152">
                <p className="font-bold text-text-main text-xs" data-id="element-153">{test.name}</p>
                <p className="text-[11px] text-text-muted" data-id="element-154">{test.details}</p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}